import {Tag} from 'antd';

// Map ranges of tips percent to icons + colors
const tipsPercentMap = [
    {max: 0, label: '0%', icon: '😕', color: 'default'},         // 0% → sad
    {max: 5, label: '1–5%', icon: '🙂', color: 'orange'},        // 1–5% → meh
    {max: 10, label: '6–10%', icon: '☺️', color: 'green'},      // 6–10% → smile
    {max: 15, label: '11–15%', icon: '😍', color: 'cyan'},       // 11–15% → happier
    {max: 20, label: '16–20%', icon: '🤯️', color: 'gold'}, // 16–20% → wow
    {max: Infinity, label: '21%+', icon: "⚡️", color: 'red'}, // >20% → shocking
];

// Render tips percent tag
export const renderTipsPercentTag = (percent) => {
    const config =
        tipsPercentMap.find((entry) => percent <= entry.max) ||
        {icon: '⁉️', color: 'default'};

    return (
        <Tag bordered={false} color={config.color}>
            {config.icon}
            <span style={{marginLeft: 4}}>{percent}%</span>
        </Tag>
    );
};


export const tipsPercentFilters = tipsPercentMap.map((entry) => ({
    text: (
        <Tag bordered={false} icon={entry.icon} color={entry.color}>
            {entry.label}
        </Tag>
    ),
    value: entry.label, // filter by label, but you could use range instead
}));
